// extracted by mini-css-extract-plugin
export default {"dialog__content":"ErrorLogDialog_dialog__content__0UJIL"};